import $ from 'jquery';
import 'jquery.ripples';

const Ripple = () => {
  const wave = function () {
    $('.bg-surface').ripples({
      interactive: false,
    });
  };

  wave();

  const rainDrops = setInterval(function () {
    const $el = $('.bg-surface');
    const x = Math.random() * $el.outerWidth();
    const y = Math.random() * ($el.outerHeight() / 3);
    const dropRadius = 280;
    const strength = 0.05 + Math.random() * 0.05;

    $el.ripples('drop', x, y, dropRadius, strength);
  }, 200);

  setTimeout(function () {
    clearInterval(rainDrops);
  }, 800);
  setTimeout(function () {
    $('.bg-surface').css('opacity', 0);
  }, 6000);
  setTimeout(function () {
    $('.bg-surface').ripples('destroy');
  }, 7000);
};

export default Ripple;
